document.addEventListener('mouseenter', (e) => {
  if (e.target.classList?.contains('animate-rotate')) {
    let rotation = parseInt(e.target.getAttribute('data-rotation') || '0', 10);
    let isHovering = e.target.getAttribute('data-hovering') === 'true';

    if (!isHovering) {
      isHovering = true;
      rotation += 90;
      e.target.style.transform = `rotate(${rotation}deg)`;

      e.target.setAttribute('data-rotation', rotation);
      e.target.setAttribute('data-hovering', 'true');
    }
  }
}, true);

document.addEventListener('mouseleave', (e) => {
  if (e.target.classList?.contains('animate-rotate')) {
    e.target.setAttribute('data-hovering', 'false');
  }
}, true);
